import { useContext } from 'react';
import { Context } from './CreateNotice';
import PropTypes from 'prop-types';
import NoticeTypeButtons from './common/NoticeTypeButtons';
import SectionAndStationSelects from './common/SectionAndStationSelects';
import ReasonButtons from './common/ReasonButtons';
import DeleteNoticeIcon from './common/DeleteNoticeIcon';

import { useTheme } from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

// 予約送信の「分」「秒」入力フォーム
const DelayTimeForm = (props) => {
  const menuItems = [];
  if (props.type === 'min') {
    for (let i = 0; i <= 9; i++) {
      menuItems.push(i);
    }
  }
  if (props.type === 'sec') {
    for (let i = 0; i <= 55; i = i + 5) {
      menuItems.push(i);
    }
  }
  return (
    <Select
      value={props.value}
      disabled={props.isImmediate}
      onChange={(event) => {
        props.onChange(event);
      }}
      IconComponent={() => null}
      sx={{
        'width': '48px', 'height': '32px', 'marginRight': '4px',
        '& .MuiOutlinedInput-input.MuiSelect-select': {
          textOverflow: 'clip',
        },
      }}
    >
      {
        menuItems.map((item) =>
          <MenuItem key={item} value={item}>{item}</MenuItem>,
        )
      }
    </Select>
  );
};

// 通告フレーム
const NoticeFrame = (props) => {
  const { typography, palette } = useTheme();
  const { notice, index } = props;
  const {
    noticeArray, setNoticeArray,
    masterData,
    isDisable,
    setOpenPreview,
    handleSubmit,
  } = useContext(Context);

  const styles = {
    headlineText: {
      ...typography.caption13bold,
      color: 'secondary.main',
    },
    checkPreviewsButton: {
      ...typography.body14bold,
      display: 'flex',
      width: '192px',
      height: '44px',
      padding: '0px 16px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      margin: '0px 8px 0px 8px',

      borderRadius: '100px',
      border: '1px solid ' + palette.primary.light,
      background: palette.white,
      color: palette.primary.light,
    },
    sendButton: {
      ...typography.body14bold,
      'width': '192px',
      'height': '44px',
      'padding': '0px 16px',
      'justifyContent': 'center',
      'alignItems': 'center',
      'gap': '8px',
      'margin': '0px 8px 0px 8px',

      'borderRadius': '100px',
      'border': '1px solid ' + palette.primary.light,
      'background': palette.primary.light,
      'color': palette.white,
      '&:hover': {
        width: '192px',
        height: '44px',
        padding: '0px 16px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        margin: '0px 8px 0px 8px',
        borderRadius: '100px',
        border: '1px solid ' + palette.primary.light,
        background: palette.primary.light,
        color: palette.white,
      },
      '&:disabled': {
        ...typography.body14bold,
        border: '1px solid ' + palette.disabledCccccc,
        color: palette.white,
        background: palette.disabledCccccc,
      },
    },
  };

  const handleChange = (inputObj, index) => {
    const newInfo = structuredClone(noticeArray);
    newInfo[index] = Object.assign(newInfo[index], inputObj);
    setNoticeArray(newInfo);
  };

  return (
    <Paper sx={{ margin: '16px 0px', padding: '24px' }} >
      <Stack direction='row' marginBottom='36px'>
        {/* 送信タイミング */}
        <Stack>
          <FormLabel required sx={styles.headlineText}>送信タイミング</FormLabel>
          <RadioGroup row sx={{ alignItems: 'center' }}>
            <FormControlLabel
              checked={notice.isImmediate}
              control={<Radio />}
              label='即時送信'
              onClick={() => {
                handleChange(
                  { delayMin: 0, delaySec: 0, isImmediate: true },
                  index,
                );
              }}
              sx={{ marginRight: '24px' }}
            />
            <FormControlLabel
              checked={!notice.isImmediate}
              control={<Radio />}
              label='予約送信'
              onClick={() => {
                handleChange({ isImmediate: false }, index);
              }}
              sx={{ marginRight: '12px' }}
            />
            <DelayTimeForm
              value={notice.delayMin}
              onChange={(event) => {
                handleChange({ delayMin: event.target.value }, index);
              }}
              isImmediate={notice.isImmediate}
              type='min'
            />
            <FormHelperText sx={{ ...typography.body16, marginRight: '4px' }}>分</FormHelperText>
            <DelayTimeForm
              value={notice.delaySec}
              onChange={(event) => {
                handleChange({ delaySec: event.target.value }, index);
              }}
              isImmediate={notice.isImmediate}
              type='sec'
            />
            <FormHelperText sx={typography.body16}>秒後</FormHelperText>
          </RadioGroup>
        </Stack>

        {/* 削除ボタン */}
        <DeleteNoticeIcon
          index={index}
          noticeArray={noticeArray}
          setNoticeArray={setNoticeArray}
        />
      </Stack>

      {/* 通告の種類 */}
      <NoticeTypeButtons
        index={index}
        notice={notice}
        handleChange={handleChange}
      />

      {/* 線区と区間 */}
      <SectionAndStationSelects
        index={index}
        notice={notice}
        handleChange={handleChange}
        masterData={masterData}
      />

      {/* 事由 */}
      <ReasonButtons
        index={index}
        reasonCode={notice.reasonCode}
        handleChange={handleChange}
      />
      <Stack direction={'row'} sx={{ width: 'fit-content', margin: '60px 0px 24px auto' }}>
        <Button variant="outlined"
          sx={{ ...styles.checkPreviewsButton, padding: '10px' }}
          disabled={isDisable()}
          onClick={() => {
            setOpenPreview({ isOpen: true, index: index });
          }}
        >
          <p>プレビューを確認する</p>
        </Button>
        <Button variant="filled"
          sx={styles.sendButton}
          disabled={isDisable()}
          onClick={() => {
            handleSubmit(index);
          }}
        >
          <p>送信する</p>
        </Button>
      </Stack>
    </Paper>
  );
};

export default NoticeFrame;

DeleteNoticeIcon.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

DelayTimeForm.propTypes = {
  value: PropTypes.number,
  isImmediate: PropTypes.bool,
  onChange: PropTypes.func,
  type: PropTypes.string,
};

NoticeFrame.propTypes = {
  notice: PropTypes.object,
  index: PropTypes.number,
};
